import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button, useToast } from '@chakra-ui/react';

import { useStore } from '../../../hooks/useStore';
import ConfirmationModal from '../../modals/ConfirmationModal';

const BypassPaymentFailures = () => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState<boolean | null>(null);
  const toast = useToast();

  const {
    userStore: { displayedUser, updateUser },
  } = useStore();

  const handleOpenModal = (enable: boolean) => {
    setPendingAction(enable);
    setIsModalOpen(true);
  };

  const handleConfirm = async () => {
    if (pendingAction === null) return;

    try {
      setLoading(true);
      await updateUser(displayedUser.id, {
        bypassPaymentFailures: pendingAction,
      });

      toast({
        title: 'Success',
        description: `Payment failures bypass ${pendingAction ? 'enabled' : 'disabled'} successfully`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (e) {
      console.error(e);
      toast({
        title: 'Error',
        description: 'Failed to update payment failures bypass',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
      setIsModalOpen(false);
      setPendingAction(null);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setPendingAction(null);
  };

  return (
    <>
      {displayedUser.bypassPaymentFailures ? (
        <Button
          w={'100%'}
          py="25px"
          color="red.400"
          variant="contained"
          border="2px"
          borderColor="red.400"
          onClick={() => handleOpenModal(false)}
          disabled={loading}
          isLoading={loading}
        >
          Disable Bypass Payment Failures
        </Button>
      ) : (
        <Button
          w={'100%'}
          py="25px"
          color="green.400"
          variant="contained"
          border="2px"
          borderColor="green.400"
          onClick={() => handleOpenModal(true)}
          disabled={loading}
          isLoading={loading}
        >
          Enable Bypass Payment Failures
        </Button>
      )}

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={handleCancel}
        title={`${pendingAction ? 'Enable' : 'Disable'} Bypass Payment Failures?`}
        subtitle={`Are you sure you want to ${pendingAction ? 'enable' : 'disable'} payment failures bypass for this user?`}
        cancelActionLabel="Cancel"
        confirmActionLabel="Confirm"
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default observer(BypassPaymentFailures);

